<template>
  <div class="section section--member section--bg">
    <div class="myPage container is-max-desktop" id="myPage">
      <h1 class="pagetitle">マイページ</h1>
      <MyPagePanel :panelList="menuList" @select="select"/>
    </div>
  </div>
</template>

<script>
import MyPagePanel from '@/components/MyPagePanel';

export default {
  name: 'CastMyPageTop',
  components: {
    MyPagePanel
  },
  data() {
    return {
      menuList: [
        { menu: "profile", icon: "profile", name: "プロフィール", text: "プロフィールを確認・編集できます。", buttonText: "プロフィールを確認" },
        { menu: "payment", icon: "payment", name: "支払い情報管理", text: "支払い方法の確認・編集、支払い履歴を確認できます。", buttonText: "支払い情報管理" },
        { menu: "doronPurchase", icon: "doro_purchase", name: "ゴールド購入", text: "ゴールドの購入を行います。", buttonText: "ゴールド購入" },
        { menu: "profilePasswordReset", icon: "profile_password_reset", name: "パスワード再設定", text: "パスワードを再設定できます。", buttonText: "パスワード再設定" },
        { menu: "reserveManager", icon: "reserve_manager", name: "限定配信予約管理", text: "限定配信予約の確認・キャンセルができます。", buttonText: "限定配信予約管理" },
      ]
    };
  },
  methods: {
    select(menu) {
      this.$router.push('/mypage/' + menu);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/myPageTop.scss';
</style>
